function remove(){var parent=this.parentNode;parent&&parent.removeChild(this)}export default function(){return this.each(remove)}